import { formStep } from './formStep';
import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';
import { thankYou } from './thankYou';

export const videoCall = {
  namespaced: true,
  modules: {
    formStep,
    iframeStep,
    infoStep,
    thankYou
  }
};
